import { useObjectUrl } from '@frontend/utils';

import {
  PartThumbnailFromUrl,
  PartThumbnailFromUrlProps,
} from './PartThumbnailFromUrl';

export type PartThumbnailFromBlobProps = Omit<
  PartThumbnailFromUrlProps,
  'thumbnailUrl'
> & {
  thumbnailBlob?: Blob | null;
};

/**
 * Renders a part thumbnail from props including the thumbnail image as a blob.
 *
 * Same props as PartThumbnailFromUrl, but with the thumbnailBlob prop instead of the
 * thumbnailUrl prop.
 *
 * In general, it is preferred to use the PartThumbnailDataWrapper component,
 * which fetches the thumbnail image based on the part file UUID from an
 * endpoint into which we are building permissions to ensure that the user
 * should be allowed to view the thumbnail, which facilitates FedRAMP
 * compliance (thumbnail images are considered CUI). There likely are valid use
 * cases for using this component directly, but do so with caution, and in a way
 * which adequately protects CUI. Can be used in concert with useBulkThumbnailLoad
 */
export const PartThumbnailFromBlob = ({
  thumbnailBlob,
  ...restProps
}: PartThumbnailFromBlobProps) => {
  const { objectUrl: thumbnailUrl } = useObjectUrl({ blob: thumbnailBlob });

  return <PartThumbnailFromUrl {...restProps} thumbnailUrl={thumbnailUrl} />;
};
